import React, { useEffect, useState } from "react";
import I18n from 'i18n.js.erb'
import { parseBigInteger } from "../../utils/utils";

const BannerSingleExpansion = ({
  expansions,
  hideCounts,
  handleShowSubExpansions,
}) => {

  const iconsToRender = expansions[0].icons_urls.map((url) => {
    return url;
  });

  let aiGCardsPopulation = 0
  expansions.forEach((expansion) => {
    aiGCardsPopulation = aiGCardsPopulation + expansion.graded_cards_population
  })

  let blueprintImagesOnMyCollection = 0
  expansions.forEach((expansion) => {
    blueprintImagesOnMyCollection = blueprintImagesOnMyCollection + expansion.blueprint_images_on_my_collection
  })

  let countueprintImages = 0
  expansions.forEach((expansion) => {
    countueprintImages = countueprintImages + expansion.count_blueprint_images
  })

  for (let i = 1; i < expansions.length; i++) {
    for (const url of expansions[i].icons_urls)
      if (!iconsToRender.includes(url)) iconsToRender.push(url);
  }

  const splittedReleasedAt = expansions[0].released_at.split('#')

  return (
      <React.Fragment>
        <div className="row justify-content-center">

          {/*time line*/}

          <div className="col-lg-2 pr-0 show-on-desktop">

            <div className="year-txt d-flex justify-content-end text-space text-weight-500 text-dark-gray w-100 position-relative">

              {splittedReleasedAt.length === 1
                  ?
                  <p className="expansion__year--center text-aiBlue">{expansions[0].released_at.toUpperCase()}</p>

                  :
                  <div className="expansion__multi-year--center text-aiBlue">
                    <p className="text-right">
                      {splittedReleasedAt[0].toUpperCase()}
                    </p>
                    <p className="sub-years text-right">
                      {splittedReleasedAt[1].toUpperCase()}
                    </p>
                  </div>
              }
            </div>

            {/*linea laterale della time line*/}
            <div
                className="chronology-marker position-relative d-flex justify-content-center align-items-center w-25">
              <div className="font-weight-light text-secondary bg-white circle"/>
            </div>

          </div>


          <div className="col-xs-12 d-flex show-on-mobile mt-30px">

            <div className="year-txt text-space text-weight-500 text-dark-gray w-100 position-relative">

              {splittedReleasedAt.length === 1
                ?
                <p className="expansion__year--center text-aiBlue">{expansions[0].released_at.toUpperCase()}</p>

                :
                <div className="expansion__multi-year--center text-aiBlue">
                  <p>
                    {splittedReleasedAt[0].toUpperCase()}
                  </p>
                  <p className="sub-years">
                    {splittedReleasedAt[1].toUpperCase()}
                  </p>
                </div>
              }
            </div>

          </div>


          {/*box con espansioni*/}
          <div className='col-xs-12 col-lg-10'>

            <div
                id="collapseHeader3"
                onClick={(e) => handleShowSubExpansions(e, expansions[0])}
                className="collapse col-12 card expansion-container  p-0 mt-3 position-relative d-flex text-night-blue"
                style={{
                  cursor:
                      expansions[0].hide_sub_expansions
                          ? "pointer"
                          : "",
                }}
            >

              <div className="row">

                <div className=" col-12 d-flex position-relative bg-hover"
                     style={{ minHeight: "80px" }}>

                  <div className="col-xs-8 col-lg-9 text-night-blue align-items-center align-self-center d-md-flex">

                      <div className="
                        expansion__expansionName--size
                        col-xs-12 col-lg-6
                         text-night-blue text-space textname
                         d-block justify-content-start align-items-center align-self-center  
                         pt-10px pb-10px pl-0 pr-0">

                        <p className="mb-0" >{expansions[0].name}</p>
                        {
                          expansions[0].en_name &&
                              <p className="mb-0">{expansions[0].en_name}</p>

                        }
                      </div>


                      <div className="col-xs-12 col-lg-6 d-flex justify-content-start align-items-center">
                        <div className="row mb-10px mt-10px">
                          {iconsToRender.map((url, i) => {
                            return (
                                <div key={url + "_" + i} className="col-xs-2 col-lg-1 mr-4">
                                  <img
                                      className="expansion__symbol--size"
                                      src={url}
                                  />
                                </div>
                            );
                          })}
                        </div>
                      </div>
                  </div>


                  {/*box dx con contatori*/}
                  <div className="col-xs-4 col-lg-3 bg-gradient-card d-flex align-items-center p-0 expansion__expansionName--size text-night-blue">
                    {
                      !hideCounts &&
                        <div className="col-12">
                          <p className=" d-flex justify-content-end text-center text-space text--white-space-break mb-0">
                            {I18n.t('js.expansionsPage.aigCard')}: {parseBigInteger(aiGCardsPopulation) }
                          </p>
                          <p className="d-flex justify-content-end text-space text-center">
                            {I18n.t('js.expansionsPage.myCollection')}: {blueprintImagesOnMyCollection}/
                            {countueprintImages}
                          </p>
                        </div>
                    }
                  </div>
                </div>
              </div>



            </div>

          </div>

        </div>
      </React.Fragment>

  );
};

export default BannerSingleExpansion;
